import PosthogService from '~/services/posthog/PosthogService';

// Event-specific interface (co-located)
export interface IPermJobOverviewAddInterviewsClickedPayload {
  postingId: string;
}

/**
 * Fires when user clicks "Add Interviews" button on the perm Job Overview screen
 * (header CTA or Interviews tab footer)
 * Event: dental_portal:perm_job_overview:add_interviews_clicked
 */
export function firePermJobOverviewAddInterviewsClicked(
  payload: IPermJobOverviewAddInterviewsClickedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:perm_job_overview:add_interviews_clicked', {
    posting_id: payload.postingId,
  });
}
